import {Row, Col, Result, Button} from 'antd';
import {FC} from 'react';
import {useTranslation} from '../../translation';
import {AppContent} from './AppContent';
import {AppFooter} from './AppFooter';
import {AppHeader} from './AppHeader';
import {AppLayout} from './AppLayout';

export const AppErrorPage: FC<{onOk?: () => void}> = (props) => {
  const {onOk} = props;
  const {t} = useTranslation();
  return (
    <AppLayout>
      <AppHeader big={false} />
      <AppContent>
        <Row justify="center">
          <Col span={24} style={{textAlign: 'center'}}>
            <Result
              status="500"
              title="500"
              subTitle={t('general.errorMessage')}
              extra={
                <Button type="primary" onClick={() => onOk?.()}>
                  {t('general.errorMessage.retryBtn')}
                </Button>
              }
            />
          </Col>
        </Row>
      </AppContent>
      <AppFooter />
    </AppLayout>
  );
};
